import video from "../assets/video.mp4"

function Video() {
  return (
    <video playsinline autoPlay muted loop src={video} className="video" />
  );
}

export default Video;
